import styled from 'styled-components'

export const Container = styled.span`
	width: 1.4em;
	height: 1em;
	display: inline-block;
	position: relative;
`
